<template>
    <div class="mt-2">
        <div
            v-if="advertiseSugarchatCustomer"
            class="shadow rounded border p-3 text-center bg-white border-brand-heavy"
        >
            <div class="d-flex align-items-center justify-content-center">
                <img
                    height="48"
                    width="48"
                    src="https://d1lil0eivvt84o.cloudfront.net/brand/sugarchat/logo-100.png"
                    class="mr-2"
                />

                <div>
                    <h1 class="branded">SugarChat</h1>
                </div>
            </div>
            <div class="small text-secondary">Powered by Findmate</div>

            <h5 class="mt-3">🎉 Our newest instance has just launched!</h5>

            <div class="small">
                Connect with Top Models, Creators & Exclusive Live Content
            </div>

            <div class="my-3">
                <b-badge variant="light" pill class="mx-2">
                    <font-awesome-icon
                        class="text-danger"
                        icon="fa-solid fa-circle"
                    ></font-awesome-icon>
                    Live Streaming & Private Calls
                </b-badge>
                <b-badge variant="light" pill class="mx-2">
                    <font-awesome-icon
                        icon="fa-duotone fa-photo-film"
                        class="text-success"
                    />
                    Private Photo &amp; Video Galleries
                </b-badge>
            </div>

            <div
                v-if="onboardingUser?.eligibleForFeeCredits"
                class="mt-3 small text-secondary"
            >
                Free credits are being granted to the first 1,000 signups
            </div>

            <b-btn
                @click="signup"
                variant="primary"
                block
                pill
                size="lg"
                class="mt-3 py-3"
            >
                <h3>Join SugarChat</h3>
                <div
                    v-if="onboardingUser?.eligibleForFeeCredits"
                    class="small text-warning"
                >
                    <coin-badge :amount="100" label="Claim Free Credits" />
                </div>
            </b-btn>

            <b-btn
                @click="sugarchatNotInterested"
                variant="light"
                block
                pill
                size="lg"
                class="mt-3"
            >
                <font-awesome-icon icon="fa-light fa-times" class="mr-1" />
                Not interested
            </b-btn>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        advertiseSugarchatCustomer() {
            return this.onboardingUser.advertiseSugarchatCustomer;
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        signup() {
            this.api
                .post("/broker/findmateCustomerToSugarchat")
                .then((response) => {
                    if (response?.data?.url) {
                        this.$store.dispatch(
                            "system/openBrowser",
                            response?.data?.url
                        );
                    }

                    this.$store.dispatch("onboarding/status");
                });
        },
        sugarchatNotInterested() {
            this.api.post("/userFlag/sugarchatNotInterested").then(() => {
                this.$store.dispatch("onboarding/status");
            });
        },
    },
};
</script>